import script from "./EmployeeHandbookSignOffCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeHandbookSignOffCompleted.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeHandbookSignOffCompleted.vue?vue&type=style&index=0&id=7c28783c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c28783c"]])

export default __exports__